import { Boton } from "./Boton";
import { Modal } from "./Modal";

export function ConfirmacionDialog({
  abierto,
  titulo,
  mensaje,
  cargando,
  onConfirmar,
  onCancelar,
  textoConfirmar = "Confirmar",
  textoCancelar = "Cancelar",
  peligroso = false,
}: {
  abierto: boolean;
  titulo: string;
  mensaje: string;
  cargando?: boolean;
  onConfirmar: () => void;
  onCancelar: () => void;
  textoConfirmar?: string;
  textoCancelar?: string;
  peligroso?: boolean;
}) {
  return (
    <Modal
      titulo={titulo}
      abierto={abierto}
      onCerrar={onCancelar}
      ancho="max-w-sm"
    >
      <p className="text-sm text-texto-secundario">{mensaje}</p>
      <div className="mt-5 flex justify-end gap-2">
        <Boton variante="secundario" onClick={onCancelar} disabled={cargando}>
          {textoCancelar}
        </Boton>
        <Boton
          variante={peligroso ? "peligro" : "primario"}
          onClick={onConfirmar}
          cargando={cargando}
        >
          {textoConfirmar}
        </Boton>
      </div>
    </Modal>
  );
}
